import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { StatsSection } from "./components/sections/StatsSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { PainPointsSection } from "./components/sections/PainPointsSection";
import { InsightSection } from "./components/sections/InsightSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ResourcesSection } from "./components/sections/ResourcesSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { AuthorSection } from "./components/sections/AuthorSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
import { Footer } from "./components/sections/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="3recerm310rgq">
      <MetaPixel data-id="element-1" data-mp="4n4pyuukj8z" />
      <Hero data-id="element-2" data-mp="56ntiw8hdol" />
      <main data-id="element-3" data-mp="82jf0klzq9v">
        <StatsSection data-id="element-4" data-mp="2zl3a7gleoy37" />
        <BeforeAfterSection data-id="element-5" data-mp="2zllcouynw8jk" />
        <PainPointsSection data-id="element-6" data-mp="2zmemy5wtxg6g" />
        <InsightSection data-id="element-7" data-mp="2zn6cp03qwjot" />
        <VolumesSection data-id="element-8" data-mp="33mf1dqjxhrdi" />
        <ResourcesSection data-id="element-9" data-mp="33nq5xsl7735o" />
        <BonusesSection data-id="element-10" data-mp="33mym1f0yqtv8" />
        <OfferSection data-id="element-11" data-mp="33oi152avuyvf" />
        <GuaranteeSection data-id="element-12" data-mp="38l8iru2c62iy" />
        <TestimonialsSection data-id="element-13" data-mp="38l03xwmnkn54" />
        <AuthorSection data-id="element-14" data-mp="38nuodo5o27yj" />
        <FaqSection data-id="element-15" data-mp="3dkurprb4swly" />
        <FinalCtaSection data-id="element-16" data-mp="3dl4lzr37lpxg" />
      </main>
      <Footer data-id="element-17" data-mp="3dm5xtxs1ugg8" />
      <FloatingCta data-id="element-18" data-mp="3dirxsw6uyjby" />
      <PurchasePopup data-id="element-19" data-mp="nvsvh92bsvy2" />
    </div>;
}